import React from 'react';
import { Box } from '@mui/material';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

interface Props {
  size?: number;
  bgColor?: string;
  iconColor?: string;
  sx?: SxProps<Theme>;
}

const HomeWorkIcon = ({
  size = 48,
  bgColor = '#F4F0EA',
  iconColor = '#91682B',
  sx,
}: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: bgColor,
        color: iconColor,
        display: 'inline-flex',
        height: size,
        justifyContent: 'center',
        width: size,
        ...sx,
      }}
    >
      <HomeWorkOutlinedIcon sx={{ fontSize: Math.round(size * 0.5) }} />
    </Box>
  );
};

export default HomeWorkIcon;
